import React from 'react';
import ReactDOM from 'react-dom';
import CartComponent from './cart.jsx';
import ContextProvider from './context.jsx';

class Cart {
  initialize = () => {
    ReactDOM.render(
      <ContextProvider>
        <CartComponent />
      </ContextProvider>,
      document.querySelector('#cart-popup-content')
    );
  };
}

export default Cart;
